import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61bb4862"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "local-security-audits" }
const _hoisted_2 = {
  key: 0,
  class: "audits-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading security audits...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "audits-error"
}
const _hoisted_7 = { class: "error-content" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "audit-header" }
const _hoisted_10 = { class: "audit-icon" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "audit-info" }
const _hoisted_13 = { class: "audit-title" }
const _hoisted_14 = { class: "audit-meta" }
const _hoisted_15 = { class: "audit-client" }
const _hoisted_16 = { class: "audit-date" }
const _hoisted_17 = { class: "audit-description" }
const _hoisted_18 = {
  key: 0,
  class: "categories-section"
}
const _hoisted_19 = { class: "category-tags" }
const _hoisted_20 = { class: "audit-links" }
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Blog Post", -1))
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "pdf-icon",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18.5,9L13,3.5V9H18.5M6,20V4H11V10H18V20H6M7,11H9V18H7V11M10,11H12A2,2 0 0,1 14,13V16A2,2 0 0,1 12,18H10V11M12,16V13H11V16H12M15,11H17V13H19V15H17V18H15V15H13V13H15V11Z" })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pdf-text" }, "PDF", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "show-more-container"
}
const _hoisted_28 = {
  key: 0,
  class: "chevron-icon",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "chevron-icon",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
}, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 3,
  class: "audits-branding"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Published Security Audits", -1))
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ion_icon, {
                name: "shield-checkmark-outline",
                class: "error-icon"
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_TransitionGroup, {
              name: "audit-list",
              tag: "div",
              class: "audits-grid"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedAudits, (audit) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: audit.id,
                    class: "audit-card"
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (audit.logoUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: audit.logoUrl,
                              alt: `${audit.project} logo`,
                              class: "audit-logo"
                            }, null, 8, _hoisted_11))
                          : (_openBlock(), _createBlock(_component_ion_icon, {
                              key: 1,
                              name: "shield-checkmark"
                            }))
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h3", _hoisted_13, _toDisplayString(audit.project), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(audit.client), 1),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatDate(audit.date)), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("p", null, _toDisplayString(audit.description), 1)
                    ]),
                    (audit.categories && audit.categories.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audit.categories, (category) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: category,
                                class: _normalizeClass(["category-tag", _ctx.getCategoryClass(category)])
                              }, _toDisplayString(category), 3))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("a", {
                        href: audit.blogUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "audit-link blog-link"
                      }, [
                        _createVNode(_component_ion_icon, { name: "document-text-outline" }),
                        _hoisted_22
                      ], 8, _hoisted_21),
                      _createElementVNode("a", {
                        href: audit.pdfUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "audit-link pdf-link",
                        title: "Download PDF Report"
                      }, _hoisted_26, 8, _hoisted_23)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            (_ctx.audits.length > _ctx.initialDisplayCount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowAll && _ctx.toggleShowAll(...args))),
                    class: "show-more-button"
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.showAll ? 'Show Less' : `Show All (${_ctx.audits.length})`), 1),
                    (_ctx.showAll)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_31, _hoisted_33))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])),
    (_ctx.showBranding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
      : _createCommentVNode("", true)
  ]))
}